var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "print-config": _vm.printConfig,
          "export-config": _vm.exportConfig,
          cellClick: _vm.chooseRow,
          cellDbClick: _vm.updateRow,
          otherParams: {
            "filter.orderByDesc.createTime": true,
            "filter.eq.jobId": _vm.jobId,
          },
        },
        on: { "toolbar-addData": _vm.addRow, "toolbar-delData": _vm.delRow },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit()
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }